"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusTrap = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const focusable_js_1 = require("../functions/focusable.js");
const useMergedRefs_js_1 = require("../hooks/useMergedRefs.js");
/**
 * Trap focus within child container.
 * Used for modals and dialogs.
 */
const FocusTrap = (props) => {
    const { children } = props;
    const childRef = React.useRef();
    const getFirstLastFocusables = () => {
        const elements = (0, focusable_js_1.getTabbableElements)(childRef.current);
        const firstElement = elements[0];
        const lastElement = elements[(elements.length || 1) - 1];
        return [firstElement, lastElement];
    };
    const onFirstFocus = (event) => {
        const [firstElement, lastElement] = getFirstLastFocusables();
        if (event.relatedTarget === firstElement) {
            lastElement === null || lastElement === void 0 ? void 0 : lastElement.focus();
        }
        else {
            firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
        }
    };
    const onLastFocus = (event) => {
        const [firstElement, lastElement] = getFirstLastFocusables();
        if (event.relatedTarget === lastElement) {
            firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
        }
        else {
            lastElement === null || lastElement === void 0 ? void 0 : lastElement.focus();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { tabIndex: 0, onFocus: onFirstFocus, "aria-hidden": true }),
        React.cloneElement(children, {
            ref: (0, useMergedRefs_js_1.mergeRefs)(children.ref, childRef),
        }),
        React.createElement("div", { tabIndex: 0, onFocus: onLastFocus, "aria-hidden": true })));
};
exports.FocusTrap = FocusTrap;
exports.default = exports.FocusTrap;
